import { Coin, CoinPair } from "@pools/types";

export const COINS: Record<string, Coin> = {
	Stablecoin: { label: "Stablecoin", symbol: "Stablecoin" },
	Bitcoin: { label: "Bitcoin", symbol: "BTC" },
	Ethereum: { label: "Ethereum", symbol: "ETH" },
	Altcoin: { label: "Altcoin", symbol: "Altcoin" },
};

export const COIN_PAIRS: CoinPair[] = [
	{
		id: `${COINS.Stablecoin.symbol}-${COINS.Stablecoin.symbol}`,
		pairs: [COINS.Stablecoin, COINS.Stablecoin],
	},
	{
		id: `${COINS.Bitcoin.symbol}-${COINS.Stablecoin.symbol}`,
		pairs: [COINS.Bitcoin, COINS.Stablecoin],
	},
	{
		id: `${COINS.Ethereum.symbol}-${COINS.Stablecoin.symbol}`,
		pairs: [COINS.Ethereum, COINS.Stablecoin],
	},
	{
		id: `${COINS.Ethereum.symbol}-${COINS.Bitcoin.symbol}`,
		pairs: [COINS.Ethereum, COINS.Bitcoin],
	},
	{
		id: `${COINS.Altcoin.symbol}-${COINS.Stablecoin.symbol}`,
		pairs: [COINS.Altcoin, COINS.Stablecoin],
	},
	{
		id: `${COINS.Ethereum.symbol}-${COINS.Altcoin.symbol}`,
		pairs: [COINS.Ethereum, COINS.Altcoin],
	},
];

export const COIN_PAIR_BY_ID = new Map(COIN_PAIRS.map((pair) => [pair.id, pair]));
